// dependencies
import { Map } from "immutable";

const initialState = Map({
	fetchedWorkflows: Map(),
});

export default function users(state = initialState, action) {
	switch (action.type) {
		case "WORKFLOWS:TEMPLATE.GET@SUCCESS": {
			const templateID = action.response.getIn(["template", "id"]);
			return state.setIn(["fetchedWorkflows", templateID], action.response);
		}

		default: {
			return state;
		}
	}
}
